import { z } from "zod";

import { taskMetadataBaseSchema } from "../taskMetadata";

/**
 * Metadata schema for `plan_revision.plan_pipeline.v1` tasks.
 *
 * The `flow` object carries rich context so the dashboard and orchestrator
 * can correlate tasks back to specific issues and revisions.
 */
export const planRevisionPlanPipelineMetadataSchema = taskMetadataBaseSchema
  .extend({
    comment_id: z.string().nullable(),
    expected_response_schema_name: z.string().optional(),
    flow: z.object({
      comment_id: z.string().nullable(),
      issue_id: z.string().nullable(),
      issue_key: z.string().nullable(),
      kind: z.string().min(1),
      organization_id: z.string().nullable(),
      project_id: z.string().nullable(),
      project_key: z.string().nullable(),
      provider_id: z.string().nullable(),
      provider_type: z.string().nullable(),
      revision_id: z.string().min(1),
    }),
    issue_id: z.string().nullable(),
    issue_key: z.string().nullable(),
    linked_task_id: z.string().nullable(),
    organization_id: z.string().nullable(),
    provider_id: z.string().nullable(),
    provider_type: z.string().nullable(),
    revision_id: z.string().min(1),
    scope: z.string(),
    skip_source_control: z.boolean().optional(),
    source: z.literal("plan_revision"),
    source_control_selected_branches: z
      .record(z.string(), z.string())
      .optional(),
  })
  .passthrough();

export type PlanRevisionPlanPipelineMetadata = z.infer<
  typeof planRevisionPlanPipelineMetadataSchema
>;
